module.exports = __webpack_public_path__ + "img/dancing-wren.8ce49fea.gif";